import React from "react";

const BuingGuideSkeleton = () => {
  const guides = [1, 2, 3];

  return (
    <div className="bg-gray-50 py-12 px-6 md:px-12">
      <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
        Buying Guides
      </h2>
      <div className="grid md:grid-cols-3 gap-8">
        {guides.map((_, idx) => (
          <div
            key={idx}
            className="bg-white rounded-xl shadow-md overflow-hidden"
          >
            <div className="h-48 bg-gray-300 animate-pulse"></div>{" "}
            {/* Image Skeleton */}
            <div className="p-6">
              <div className="flex items-center text-sm text-gray-500 space-x-4 mb-2">
                <div className="flex items-center space-x-1">
                  <div className="w-4 h-4 bg-gray-300 rounded-full animate-pulse"></div>
                  <span className="w-16 h-3 bg-gray-200 animate-pulse rounded"></span>
                </div>
                <div className="flex items-center space-x-1">
                  <div className="w-4 h-4 bg-gray-300 rounded-full animate-pulse"></div>
                  <span className="w-12 h-3 bg-gray-200 animate-pulse rounded"></span>
                </div>
              </div>
              <div className="h-5 bg-gray-300 rounded w-3/4 mb-4 animate-pulse"></div>
              <div className="space-y-2">
                <div className="h-3 bg-gray-200 rounded w-full animate-pulse"></div>
                <div className="h-3 bg-gray-200 rounded w-5/6 animate-pulse"></div>
              </div>
              <div className="mt-4 space-y-2">
                <div className="h-2.5 w-32 bg-orange-400 rounded-full animate-pulse"></div>
                <div className="h-2.5 w-36 bg-orange-400 rounded-full animate-pulse"></div>
              </div>
              <div className="mt-6">
                <div className="w-32 h-4 bg-orange-500 text-white rounded-full animate-pulse"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BuingGuideSkeleton;
